module.exports = __webpack_public_path__ + "img/black.2cd1a42e.png";